import { render, staticRenderFns } from "./regionalDirectorList.vue?vue&type=template&id=53973e6e&"
import script from "./regionalDirectorList.vue?vue&type=script&lang=js&"
export * from "./regionalDirectorList.vue?vue&type=script&lang=js&"
import style0 from "./regionalDirectorList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports